<!-- dashboard.component.html -->
<div class="bg-gray-100 font-sans antialiased min-h-screen">
    <!-- Header Section -->
    <div class="flex flex-col md:flex-row items-center justify-between p-4 md:px-8 md:py-6">
        <!-- Logo -->
        <div class="mb-4 md:mb-0 md:ml-4">
            <img alt="Logo" class="h-20 md:h-24 w-auto" src="assets/companyLogo.png"/>
        </div>

        <!-- Search and Icons -->
        <div class="w-1/2 md:w-auto   md:flex-row  md:space-y-0 md:space-x-6 lg:mr-24">
            <!-- Search Bar -->
            <!-- <div class="w-full md:w-64 flex items-center bg-white rounded-full px-4 py-2 shadow-sm">
                <input class="flex-1 bg-transparent outline-none text-sm"
                       placeholder="Try Searching"
                       type="text"/>
                <i class="fas fa-search text-gray-400 ml-2"></i>
            </div> -->

            <!-- Icons -->
            <div class="flex  space-x-6 md:space-x-8">
                <i class="fas fa-bell text-purple-700 relative text-lg">
                    <span class="absolute top-0 right-0 inline-block w-2 h-2 bg-red-600 rounded-full"></span>
                </i>
                <i class="fas fa-envelope text-gray-400 text-lg"></i>
                <i class="fas fa-user text-gray-400 text-lg"></i>
                <i class="fas fa-sign-out-alt text-gray-400 text-lg cursor-pointer" 
                   (click)="onLogoutClick()"></i>
            </div>
        </div>
    </div>


    <!-- Main Content -->
    <div class="flex flex-col md:flex-row px-4 pb-4">
        <!-- Sidebar -->
        <div class="w-full md:w-64 bg-white rounded-lg shadow-md mb-4 md:mb-0 md:mr-6">
            <nav class="p-4 space-y-2">
                <a class="flex items-center p-3 rounded-lg bg-purple-50 text-purple-700">
                    <i class="fas fa-home mr-3"></i>
                    <span class="text-sm font-medium">Dashboard</span>
                </a>
                <a class="flex items-center p-3 rounded-lg hover:bg-purple-50 text-gray-600"
                   (click)="onclinicClick()">
                    <i class="fas fa-clinic-medical mr-3"></i>
                    <span class="text-sm font-medium">Clinics</span>
                </a>
            </nav>
        </div>

        <!-- Content Area -->
        <div class="flex-1">
            <!-- Stats Cards -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <!-- Total Reports Card -->
                <div class="bg-white p-4 rounded-lg shadow-sm">
                    <div class="flex justify-between items-center">
                        <div>
                            <p class="text-xs text-gray-500">Total Reports</p>
                            <p class="text-2xl font-bold text-purple-600">{{stats.totalReports | number}}</p>
                        </div>
                        <div class="bg-purple-100 p-2 rounded-full">
                            <i class="fas fa-file-alt text-purple-600"></i>
                        </div>
                    </div>
                </div>

                <!-- Control Tests Card -->
                <div class="bg-white p-4 rounded-lg shadow-sm">
                    <div class="flex justify-between items-center">
                        <div>
                            <p class="text-xs text-gray-500">Control Tests</p>
                            <p class="text-2xl font-bold text-purple-600">{{controlTest}}</p>
                        </div>
                        <div class="bg-purple-100 p-2 rounded-full">
                            <i class="fas fa-check-circle text-purple-600"></i>
                        </div>
                    </div>
                </div>

                <!-- Implant Test Card -->
                <div class="bg-white p-4 rounded-lg shadow-sm">
                    <div class="flex justify-between items-center">
                        <div>
                            <p class="text-xs text-gray-500">Implant Test</p>
                            <p class="text-2xl font-bold text-purple-600">{{ implantTest }}</p>
                        </div>
                        <div class="bg-purple-100 p-2 rounded-full">
                            <i class="fas fa-clock text-purple-600"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Charts Section -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div class="bg-white p-4 rounded-lg shadow-sm">
                    <h2 class="text-lg font-semibold text-purple-600 mb-4">Weekly Test Summary</h2>
                    <div class="w-full h-64">
                        <canvas id="mainChart"></canvas>
                    </div>
                </div>
                <div class="bg-white p-4 rounded-lg shadow-sm">
                    <h2 class="text-lg font-semibold text-purple-600 mb-4">Test Type Distribution</h2>
                    <div class="w-full h-64">
                        <canvas id="doughnutChart"></canvas>
                    </div>
                </div>
            </div>

            <!-- Reports Section -->
            <div class="bg-white rounded-lg shadow-sm p-4">
                <!-- Filters -->
                <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-6 space-y-4 md:space-y-0">
                    <div class="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
                        <div class="flex items-center">
                            <label class="text-xs md:text-sm text-purple-700 mr-2">Start Time</label>
                            <input type="date" 
                                   [(ngModel)]="startTime"
                                   (change)="onDateChange()"
                                   class="p-1 md:p-2 text-xs md:text-sm border rounded">
                        </div>
                        <div class="flex items-center">
                            <label class="text-xs md:text-sm text-purple-700 mr-2">End Time</label>
                            <input type="date" 
                                   [(ngModel)]="endTime"
                                   (change)="onDateChange()"
                                   class="p-1 md:p-2 text-xs md:text-sm border rounded">
                        </div>
                    </div>
                    <div class="flex space-x-2">
                        <button class="text-xs md:text-sm px-3 py-1 bg-gray-500 text-white rounded hover:bg-gray-600"
                                (click)="exportExcel()">
                            Export Excel
                        </button>
                        <button class="text-xs md:text-sm px-3 py-1 bg-purple-500 text-white rounded hover:bg-purple-600"
                                (click)="exportPDF()">
                            Export PDF
                        </button>
                    </div>
                </div>

                <!-- Table -->
                <div class="overflow-x-auto">
                    <table class="w-full min-w-[800px] md:min-w-0">
                        <thead class="bg-purple-50">
                            <tr>
                                <th class="text-xs md:text-sm p-2 text-left">#</th>
                                <th class="text-xs md:text-sm p-2 text-left">Start Time</th>
                                <th class="text-xs md:text-sm p-2 text-left">End Time</th>
                                <th class="text-xs md:text-sm p-2 text-left">Well Number</th>
                                <th class="text-xs md:text-sm p-2 text-left">Serial Number</th>
                                <th class="text-xs md:text-sm p-2 text-left">Result</th>
                                <th class="text-xs md:text-sm p-2 text-left">BI Type</th>
                                <th class="text-xs md:text-sm p-2 text-left">BI Lot Number</th>
                                <th class="text-xs md:text-sm p-2 text-left">Sterilizer Model</th>
                                <th class="text-xs md:text-sm p-2 text-left">Load Number</th>
                                <th class="text-xs md:text-sm p-2 text-left">Team Member</th>
                                <th class="text-xs md:text-sm p-2 text-left">Cycle</th>
                                <th class="text-xs md:text-sm p-2 text-left">Chemical Integrator</th>
                                <th class="text-xs md:text-sm p-2 text-left">Control</th>
                                <th class="text-xs md:text-sm p-2 text-left">Implant</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let record of records; let i = index" 
                                class="border-t hover:bg-gray-50">
                                <td class="text-xs md:text-sm p-2 whitespace-nowrap">{{ i+1 }}</td>
                                <td class="text-xs md:text-sm p-2 whitespace-nowrap">
                                    {{ record.startTime | date:'dd-MM-yy HH:mm' }}
                                </td>
                                <td class="text-xs md:text-sm p-2 whitespace-nowrap">
                                    {{ record.endTime | date:'dd-MM-yy HH:mm' }}
                                </td>
                                <td class="text-xs md:text-sm p-2">{{ record.wellNumber }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.serialNumber }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.result }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.biType }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.biLotNumber }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.sterilizerModels }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.loadNumber }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.technicianNames }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.cycleCount }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.chemicalIntegrators }}</td>
                                <td class="text-xs md:text-sm p-2">
                                    <button class="text-purple-600 hover:text-purple-800 text-xs md:text-sm px-2 py-1 border rounded disabled:opacity-50"
                                            [disabled]="!record.isControlTest">
                                        Control
                                    </button>
                                </td>
                                <td class="text-xs md:text-sm p-2">
                                    <button class="text-purple-600 hover:text-purple-800 text-xs md:text-sm px-2 py-1 border rounded disabled:opacity-50"
                                            [disabled]="!record.isImplant">
                                        Implant
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Pagination -->
                <div class="flex flex-col md:flex-row justify-between items-center mt-6 space-y-4 md:space-y-0">
                    <span class="text-xs md:text-sm text-gray-600">
                        Showing {{ currentPage + 1 }}  of {{ totalPages }}
                    </span>
                    <div class="flex space-x-2">
                        <button class="px-3 py-1 text-xs md:text-sm bg-purple-500 text-white rounded hover:bg-purple-600 disabled:opacity-50"
                                (click)="changePage(currentPage - 1)" 
                                [disabled]="currentPage === 0">
                            Previous
                        </button>
                        <button class="px-3 py-1 text-xs md:text-sm bg-purple-500 text-white rounded hover:bg-purple-600 disabled:opacity-50"
                                (click)="changePage(currentPage + 1)" 
                                [disabled]="currentPage === totalPages">
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-notification-popup
        [isOpen]="showPopup"
        [message]="popupMessage"
        [type]="popupType"
        (onClose)="closePopup()">
    </app-notification-popup>
</div>